"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
const signatureItems = [{
  id: 1,
  title: "Live Room A: Natural Reverb",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/live_room_a_acoustic_setup.png"
}, {
  id: 2,
  title: "Control Room: Precision Mixing",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/control_room_mixing_desk.png"
}, {
  id: 3,
  title: "Vocal Booth: Pure Isolation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/vocal_booth_isolation_chamber.png"
}, {
  id: 4,
  title: "Mastering Suite: Final Polish",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/mastering_suite_analog_gear.png"
}, {
  id: 5,
  title: "The Lounge: Creative Flow",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/studio_lounge_creative_space.png"
}, {
  id: 6,
  title: "Drum Room: Punchy Dynamics",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/drum_room_acoustic_treatment.png"
}];
export default function ArtisanalPresentation() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  return <section data-section-id="226220" id="studio-environment" className="bg-background text-foreground py-16 md:py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 mb-12 md:mb-24 text-center">
        <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tighter mb-6 text-foreground">
          The Environment
        </h2>
        <p className="text-muted-foreground max-w-2xl mx-auto font-default font-medium text-lg">
          Explore our high-fidelity recording spaces, engineered for acoustic perfection and artistic inspiration.
        </p>
      </div>

      <div className="w-full px-4 md:px-8 lg:px-16">
        <Carousel setApi={setApi} opts={{
        loop: true,
        align: "center"
      }} className="w-full relative">
          <CarouselContent>
            {signatureItems.map((item, i) => <CarouselItem key={item.id} data-index={i}>
                {}
                <div className="relative w-full h-[50vh] md:h-[70vh] lg:h-[80vh] bg-card flex items-center justify-center p-6 md:p-16 lg:p-32 border border-border/50">
                  
                  {}
                  <div className="relative w-full h-full max-w-6xl mx-auto shadow-4xl bg-background overflow-hidden rounded-3xl">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-1000 hover:scale-105" />
                    {}
                    <div className="absolute inset-0 shadow-[inset_0_0_120px_rgba(0,0,0,0.8)] pointer-events-none" />
                  </div>

                  {}
                  <div className="absolute top-6 left-6 md:top-12 md:left-12">
                    <h3 className="text-xs md:text-sm font-mono text-primary tracking-[0.4em] uppercase">
                      {item.title}
                    </h3>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="container mx-auto mt-8 flex flex-col md:flex-row items-center justify-between gap-6 px-4">
            <div className="flex items-center gap-4">
              <CarouselPrevious className="static translate-y-0 translate-x-0 size-12 rounded-full border-primary/30 text-primary hover:bg-primary/20 hover:text-primary transition-all shadow-lg shadow-primary/10" />
              <CarouselNext className="static translate-y-0 translate-x-0 size-12 rounded-full border-primary/30 text-primary hover:bg-primary/20 hover:text-primary transition-all shadow-lg shadow-primary/10" />
            </div>
            
            {}
            <div className="text-primary font-mono text-sm tracking-widest flex items-center gap-2">
              <span className="opacity-100 font-bold">{String(current).padStart(2, "0")}</span>
              <span className="opacity-30">/</span>
              <span className="opacity-50">{String(count).padStart(2, "0")}</span>
            </div>
          </div>
        </Carousel>
      </div>
    </section>;
}